class ScheduleMedicationParams {
  encounter!: string | number;
  solutionNumber!: number;
  step!: number;
  scheduleSequenceNumber!: number;
}

interface ResponseConsist {
  eliminatedList?: string;
  inconsistentBatchDescription?: string;
  message: number;
}

interface ReasonField {
  reasonDescription: string,
  reasonStatus: string,
  sequenceNumber: number | string
}

enum CanScheduleTime {
  JUSTIFICATION = 'J',
  REASON = 'M',
  BOTH = 'A',
  NONE = 'N'
}

export {
  ScheduleMedicationParams,
  ResponseConsist,
  ReasonField,
  CanScheduleTime,
  InfoSchedules,
  ResponseSaveStandardSchedules
}

type InfoSchedules = {
  schedules: string,
}

type ResponseSaveStandardSchedules = {
  errorDescription: string,
  result: string,
}